import { LOGIN_DOMAIN, LOGIN_API_DOMAIN, CERT_DOMAIN } from "@core/constants/service";
import type { networkType } from "@core/types/uiType";

export function getLoginUrl(network: networkType, returnUrl?: string) {
  return `${LOGIN_DOMAIN[network]}/nclogin/signin?return_url=${returnUrl || window.location.href}`;
}

export function getJoinUrl(network: networkType) {
  return `${LOGIN_DOMAIN[network]}/nclogin/signup?return_url=${window.location.origin}/account/register`;
}

export function getLogoutUrl(network: networkType) {
  return `${LOGIN_API_DOMAIN[network]}/login/logout`;
}

export function getCertUrl(network: networkType) {
  return `${CERT_DOMAIN[network]}/cert/main/intro`;
}
